export default {
  home: {
    hello: 'Hei',
    newMessage: 'Du har en ny melding!',
    newMessages: 'Du har nye meldinger!',
    digitalHealthConsultationTitle: 'Digital helsesamtale',
    viewBookingDetails: 'Se bestillingsdetaljer',
    healthPlanTitle: 'Direkte tilgang til din individuelle helseplan',
    digDeeperTitle: 'Fordyp deg',
    discoverMore: 'Oppdag mer',
    podcastTitle: 'Ikke gå glipp av podden vår - Gynpodden',
    podcastDescription:
      'I Gynpodden snakker vi om kvinnekroppen og likestilling fra et vitenskapelig perspektiv. Personlige historier veksles med emner der vi inviterer Sveriges fremste eksperter for å spre kunnskap sammen.',
    allPodcastEpisodes: 'Til alle våre podkastepisoder',
    messageQuestion: 'Har du spørsmål om helsen din eller helseplanen?',
    messageTitle: 'Send melding til EsterCares helseteam',
    messageDescription:
      'Har du spørsmål om helsen din eller helseplanen? Send melding til EsterCares helseteam og få individuell veiledning når du trenger det. Ingen spørsmål er for små – vi er her for å støtte deg. Helseteamet vårt svarer vanligvis innen 24 timer på hverdager.',
  },
  healthCall: {
    callsRemaining: 'Du har {{count}}/{{total}} digitale helsesamtaler igjen å bruke.',
    step1Title: 'Bestill en helsesamtale',
    step1Description:
      'Start med å fylle inn opplysningene dine og velg deretter et tidspunkt som passer for deg. Når bestillingen er gjennomført, sendes en bekreftelse til e-posten din.',
    goToCalendar: 'Velg tid for helsesamtale',
    journalText:
      'Helsesamtalen bestilles i journalsystemet vårt, og opplysningene dine behandles der etter den svenske pasientdataloven (Patientdatalagen). Arbeidsgiveren din har aldri tilgang til dem.',
    journalCheckbox: 'Jeg har lest informasjonen og vil bestille helsesamtalen.',
    journalConsentError: 'Noe gikk galt da godkjenningen din skulle lagres. Vennligst prøv igjen senere.',
    step2Title: 'Last ned appen vår',
    step2Description:
      'Søk etter "EsterCare" i App Store eller Google Play, eller skann QR-koden for å laste ned EsterCare-appen direkte:',
    step3Title: 'Logg inn og gjennomfør samtalen din',
    step3Description:
      'Du logger enkelt inn i appen vår med BankID og gjennomfører deretter samtalen i EsterCare-appen. Du kan koble deg til møtet 5 minutter før din avtalte tid.',
    completedTitle: '{{total}} av {{total}} helsesamtaler gjennomført',
    completedDescription:
      'Du har gjennomført de tre helsesamtalene som er betalt av {{organisationName}}. Du får tilgang til ytterligere tre samtaler neste år.',
    howToPerform: 'Hvordan gjennomfører jeg helsesamtalen?',
    modalTitle: 'Opplysningene dine',
    modalDescription:
      'Fyll inn opplysningene dine, så kommer vi tilbake til deg med en bekreftelse på bestillingen innen kort tid.',
    errorMessage: 'Noe gikk galt, vennligst kontroller at opplysningene dine er korrekte.',
    personalNumber: 'Fødselsnummer',
    phoneNumber: 'Telefonnummer',
    phoneNumberPlaceholder: '+4790XXXXXXX',
    personalNumberPlaceholder: 'DDMMÅÅÅÅ-XXXX',
    personalNumberValidationError: 'Angi i formatet DDMMÅÅÅÅ-XXXX',
    personalNumberRequired: 'Fødselsnummer kreves',
    phoneNumberValidationError: 'Ugyldig telefonnummer. Må være i formatet: +4790XXXXXXX',
    phoneNumberRequired: 'Telefonnummer kreves',
    bookingInfo: 'Digitalt videomøte - logg inn i EsterCare-appen for å gjennomføre møtet',
    bookingDetails: 'Bestillingsdetaljene dine',
    cancelWarning:
      'Hvis du avbestiller helsesamtalen din mindre enn 24 timer før avtalt tid, regnes det som en gjennomført helsesamtale.',
    cancelError: 'Det var ikke mulig å avbestille helsesamtalen din. Vennligst prøv igjen eller kontakt support.',
    cancelBooking: 'Avbestill helsesamtalen din',
    cancelConfirmation: 'Er du sikker på at du vil avbestille?',
    todayAt: 'I dag kl.',
    tomorrowAt: 'I morgen kl.',
    time: 'kl.',
    calendarTitle: 'Digital helsesamtale',
    calendarDescription:
      'Book en videosamtale med en av våre jordmødre for å få personlig rådgivning og støtte rundt helsen din.',
    confirmBooking: 'Bekreft booking',
    fullyBooked: 'Fullbooket',
    loading: 'Laster tider...',
    error: 'En feil oppstod',
    timeSlotErrorMessage: 'Kunne ikke laste tilgjengelige tider. Prøv igjen.',
    duration: '15 min',
    meetingType: 'Digital videosamtale',
    confirmTitle: 'Bekreft bookingen din',
    cancellationPolicy:
      'Du kan avbestille eller endre din helsesamtale senest 24 timer før møtet. Ved uteblivelse eller avbestilling senere enn 24 timer før, regnes det som en forbrukt helsesamtale.',
    bookingError: 'Det var ikke mulig å bestille helsesamtalen. Vennligst prøv igjen.',
    timeslotExpired: 'Tiden er ikke lenger tilgjengelig',
    timeslotExpiredMessage:
      'Den valgte tiden har dessverre passert eller er ikke lenger mulig å bestille. Vennligst velg en ny tid.',
    timeslotExpiredButton: 'Velg ny tid',
    cancelSuccess: 'Din helsesamtale er avbestilt.',
    cancelSuccessTitle: 'Bestilling avbestilt',
    cancelSuccessMessage: 'Din helsesamtale er avbestilt.',
    notAvailableTitle: 'Tjenesten er ikke tilgjengelig',
    notAvailableMessage: 'Helsesamtaler er for øyeblikket ikke tilgjengelige for brukere i dette markedet.',
    returnToHome: 'Tilbake til forsiden',
  },
  screening: {
    basedOnDate: 'Basert på din screening fra {{date}}',
    recommendationsHelperText:
      'Trenger du en liten oppfriskning? Her kan du lese gjennom rådene vi ga om egenomsorg i helseplanen din.',
    showRecommendations: 'Vis anbefalingene dine',
    hideRecommendations: 'Skjul anbefalingene dine',
    followUpDescription:
      'Nå er det på tide å følge opp for å se hvordan de siste månedene har vært og hvordan du har det i dag.\n\nSvarene dine hjelper oss å gi deg mer relevante anbefalinger fremover og oppdatere grafene over velværet ditt, slik at du kan følge hvordan helsen din utvikler seg over tid.\n\nOppfølgingen tar cirka 5 minutter å gjennomføre.',
    standardDescription:
      'Ved å svare på screeningspørsmål hjelper vi deg med å identifisere plager som påvirker helsen din. Du får en personlig analyse og en konkret helseplan som kan hjelpe deg å ta neste steg mot bedre velvære. Svarene dine er konfidensielle og deles ikke med {{organisationName}}.\n\nScreeningen tar cirka 15 minutter å gjennomføre.',
    invitedStandardDescription:
      'Ved å svare på screeningspørsmål hjelper vi deg med å identifisere plager som påvirker helsen din. Du får en personlig analyse og en konkret helseplan som kan hjelpe deg å ta neste steg mot bedre velvære. Svarene dine er konfidensielle.\n\nScreeningen tar cirka 15 minutter å gjennomføre.',
    invitedFollowUpDescription:
      'Det er nå på tide å følge opp hvordan du har det basert på svarene du ga i screeningen i {{date}}.\n\nVed å svare på spørsmålene i oppfølgingen kan vi se om plagene dine har blitt bedre eller ikke, og du får oppdaterte råd i retur. Svarene dine er konfidensielle.\n\nOppfølgingen tar cirka 2 minutter å gjennomføre.',
    submitTitle: 'På tide å sende inn!',
    submitButton: 'Send inn',
    submitPreviousError:
      'Det var ikke mulig å gå til forrige spørsmål. Vennligst prøv igjen eller kontakt support på support@estercare.com',
    submitError:
      'Det var ikke mulig å sende inn screeningen. Vennligst prøv igjen eller kontakt support på support@estercare.com',
    errorTitle: 'Noe gikk galt!',
    nextQuestionError:
      'Det var ikke mulig å gå til neste spørsmål. Vennligst prøv igjen eller kontakt support på support@estercare.com',
    previousQuestionError:
      'Det var ikke mulig å gå til forrige spørsmål. Vennligst prøv igjen eller kontakt support på support@estercare.com',
    generalError: 'Noe gikk galt. Prøv igjen!',
    continueButton: 'Fortsett',
    nextQuestionButton: 'Neste spørsmål',
    standardTitle: 'Screeningtjeneste for kvinnehelse',
    standardNotStartedPage: 'Start screening',
    standardContinuePage: 'Fortsett med screeningen',
    standardNotStartedButton: 'Start screening',
    standardContinueButton: 'Fortsett med screeningen',
    standardCompletedTitle: 'Din screening er behandlet!',
    standardCompletedDescription: 'Se din personlige analyse og helseplan under Din helseplan.',
    standardCompletedButton: 'Gå til din helseplan',
    standardCompletedPending: 'Din screening behandles',
    standardPendingDescription:
      'Din screening er sendt inn og behandles nå av våre eksperter. Innen 3 arbeidsdager får du en e-post når din personlige analyse og helseplan er klar.',
    consentAgree:
      'Jeg samtykker til at EsterCare behandler helseopplysningene mine for screening, helseplan, oppfølging og meldinger i henhold til',
    dataProcessing: 'personvernerklæringen',
    consentWithdraw: '. Jeg kan trekke tilbake samtykket når som helst.',
    journalTitle: 'Lagre screeningen din før et legebesøk (frivillig).',
    journalText:
      'Vi lagrer et sammendrag av screeningen din i journalsystemet vårt, slik at legen kan lese det hvis du senere bestiller en legetime hos oss. Det krever fødselsnummeret ditt. Sammendraget behandles etter den svenske pasientdataloven (Patientdatalagen), og arbeidsgiveren din har aldri tilgang til det.',
    journalCheckbox: 'Ja, lagre et sammendrag av screeningen min i journalsystemet.',
    consentError: 'Noe gikk galt da samtykket skulle lagres. Prøv igjen senere.',
    followUpTitle: 'Oppfølging av screeningen din',
    followUpNotStartedPage: 'Start oppfølging',
    followUpContinuePage: 'Fortsett med oppfølgingen',
    followUpNotStartedButton: 'Start oppfølging',
    followUpContinueButton: 'Fortsett med oppfølgingen',
    followUpCompletedPage: 'Oppfølging',
    followUpCompletedTitle: 'Oppfølgingen din er behandlet!',
    followUpCompletedDescription: 'Se din personlige analyse og helseplan under Din helseplan.',
    followUpCompletedButton: 'Gå til Din helseplan',
    followUpPendingPage: 'Oppfølgingen din behandles',
    followUpPendingTitle: 'Oppfølgingen din behandles',
    followUpPendingDescription:
      'Oppfølgingen din er sendt inn og behandles nå av våre eksperter. Innen 3 arbeidsdager vil du motta en e-post når din personlige analyse og helseplan er oppdatert.',
    checkInTitle: 'Hei {{firstName}}!',
    checkInDescription: 'I {{date}} gjorde du en screening, hvordan har det gått siden da?',
    outcomesTitle: 'Dine utfall basert på din screening fra {{date}}',
    outcomesDescription:
      'I screeningen din ble følgende områder identifisert — det er disse vi ønsker å følge opp i dag.',
    checkInNotStartedPage: 'Innsjekking',
    checkInNotStartedButton: 'Start innsjekking',
    checkInContinuePage: 'Innsjekking',
    checkInContinueButton: 'Fortsett innsjekking',
    bookHealthCallPage: 'Helsesamtale',
    bookHealthCallTitle: 'Ønsker du å bestille en helsesamtale?',
    bookHealthCallDescription:
      'Under en helsesamtale får du møte en jordmor digitalt og gjennomgå resultatet fra screeningen din. Du har også mulighet til å stille spørsmål om allmenntilstanden din og ved behov bli booket inn til en konsultasjon.',
    bookHealthCallButton: 'Bestill helsesamtale',
    under15Warning: 'Du får tilgang til screeningen fra og med det året du fyller 15.',
    maleUserTitle: 'Her kan kvinnelige brukere starte sin screening.',
    maleUserDescription: 'Du har oppgitt at ditt biologiske kjønn er mann.',
    giftHeading: 'Gi bort en screening i kvinnehelse',
    giftDescription:
      'Vår screening er utviklet for å gi kvinner personlige innsikter og konkrete anbefalinger om helsen sin.\n\nSom mann har du muligheten til å gi bort en screening med tilhørende helseplan til noen du bryr deg om – for eksempel en partner, søster, datter eller venn.\n\nDet tar bare noen minutter å sende en invitasjon og kan gjøre stor forskjell for noens helse.',
    giftButton: 'Gi bort en screening',
    giftModalTitle: 'Gi bort en screening',
    maleScreeningTitle: 'Screeningtjeneste',
    giftModalDescription: 'Send en invitasjon til EsterCares helseportal.\nKontoen er helt separat fra din.',
    giftFirstName: 'Fornavn',
    giftLastName: 'Etternavn',
    giftEmail: 'E-post',
    giftSendButton: 'Send invitasjon',
    giftSuccessTitle: 'Invitasjon sendt!',
    giftSuccessDescription: 'En invitasjon har blitt sendt til {{email}}.',
    giftAlreadyInvited: 'Du har allerede sendt en invitasjon.',
    giftError: 'Noe gikk galt da invitasjonen skulle sendes. Prøv igjen.',
    renewScreeningTitle: 'På tide med en ny screening!',
    renewScreeningDescription:
      'Nå har det gått et år siden du gjennomførte din siste screening. Vi anbefaler at du gjør screeningen på nytt slik at vi kan fortsette å gi deg relevante råd og anbefalinger.',
    renewScreeningButton: 'Start screening',
    previousRating: 'Senest skattade du {{rating}} av {{max}}',
  },
  yourHealth: {
    wellbeing: 'Ditt velvære',
    overallWellbeingScore: 'Din allmenntilstand',
    symptomTrendsTitle: 'Symptomtrender over tid',
    symptomTrendsDescription:
      'Følg hvordan enkeltsymptomer endrer seg mellom screeninger for bedre å forstå hvordan velværet ditt utvikler seg over tid.',
    topSymptomsOverview: 'Oversikt over dine fremste symptomer',
    graphsBreakdownTitle: 'Din helse i detalj',
    graphsBreakdownDescription: 'Se hvordan symptomene og velværet ditt utvikler seg og påvirker hverdagen din.',
    severity: 'Alvorlighetsgrad',
    everydayImpact: 'Påvirkning på hverdagen',
    healthPlanTab: 'Helseplan',
    healthProgressTab: 'Helse over tid',
    noScreeningDescription:
      'Her finner du din personlige helseplan.\nI helseplanen hjelper vi deg med å identifisere eventuelle problemområder, forebygge fremtidige plager og styrke helsen din.\nFor at vi skal kunne lage den, må du først gjennomføre screeningen vår.',
    pendingMessage:
      'Når du har gjennomført screeningen din og vi har analysert svarene dine, vil din personlige helseplan vises her. Analysen kan ta opptil 3 virkedager.',
    promptStartTitle: 'På tide å gjennomføre helsescreeningen din',
    promptStartDescription:
      'Ved å svare på screeningspørsmålene hjelper vi deg med å identifisere plager som påvirker helsen din. Du får en personlig analyse og en skreddersydd helseplan.',
    promptStartButton: 'Start screening',
    promptContinueTitle: 'Fullfør helsescreeningen din',
    promptContinueDescription: 'Du har påbegynt screeningen din. Fullfør den for å få din personlige helseplan.',
    promptContinueButton: 'Fortsett screening',
    promptFollowUpStartTitle: 'Tid for oppfølgingen din',
    promptFollowUpStartDescription:
      'Det er nå tid for å følge opp hvordan du har det basert på dine tidligere svar. Gjennom oppfølgingen kan vi se om plagene dine har blitt bedre.',
    promptFollowUpStartButton: 'Start oppfølging',
    promptFollowUpContinueTitle: 'Fullfør oppfølgingen din',
    promptFollowUpContinueDescription:
      'Du har påbegynt oppfølgingen din. Fullfør den for å få oppdaterte anbefalinger.',
    promptFollowUpContinueButton: 'Fortsett oppfølging',
    healthPlanSummary: 'Din helseplan i korte trekk',
    helloGreeting: 'Hei, {{firstName}}!',
    healthPlanCardsTitle: 'Dine anbefalinger',
    healthPlanCardsDescription:
      'Råd og anbefalinger innen kosthold, trening, stressmestring, psykisk velvære, søvn og livsstil – tilpasset dine behov.',
    needHealthCare: 'Trenger du å søke helsehjelp?',
    gynocologistOfficeTitle: 'Gynekologmottak',
    gynocologistOfficeDescription:
      'Vær oppmerksom på at det i noen regioner kreves en henvisning for å komme til gynekolog, mens du i andre regioner kan bestille time direkte. Gå inn på 1177 for informasjon om hva som gjelder der du bor.',
    physicalClinicTitle: 'EsterCares fysiske mottak',
    physicalClinicDescription:
      'For et fysisk besøk hos en gynekolog i Stockholm kan du bestille time på vårt gynekologmottak på Torsplan. Dette gjør du ved å ringe 08-60 90 270. Vårt mottak er regionstilknyttet, noe som betyr at du betaler en pasientavgift på 275 kr, frikort gjelder.',
    digitalClinicTitle: 'EsterCares digitale mottak',
    digitalClinicDescription:
      'Du kan bestille et digitalt besøk hos en gynekolog via vår EsterCare-app. Vårt mottak er regionstilknyttet, noe som betyr at du betaler en pasientavgift på 100 kr for et digitalt besøk, frikort gjelder.',
    learnMore: 'Les mer',
    yourOutcomes: 'Dine resultater',
    yourOutcomesDescription:
      'Basert på screeningen din har vi identifisert følgende resultater som kan være relevante for deg.',
    yourWellbeingTitle: 'Din allmenntilstand over tid',
    yourCheckList: 'Din sjekkliste',
    translationsMissing1:
      'En oversettelse av helseplanen din er for øyeblikket ufullstendig eller ikke tilgjengelig på språket du har valgt. Vennligst kontakt support for hjelp.',
    translationsMissing2:
      'Om du nylig har endret språkinnstillingene dine kan det ta noen minutter før alt innholdet er oppdatert. Prøv å oppdatere siden om en liten stund.',
    showLess: 'Vis mindre',
    askUs: 'Chat med oss',
    askUsHeader: 'Chat',
    askUsTitle: 'Helseteamet ditt er her for deg',
    askUsDescription:
      'Still spørsmål, del bekymringer eller få veiledning om helseplanen din og velværet ditt. Ingen spørsmål er for små – vi er her for å støtte deg.',
    askUsCta: 'Start en samtale',
    followUpUpdated: 'Oppdaterte anbefalinger!',
    followUpUpdatedDate: 'Basert på oppfølgingen din i {{date}}',
    followUpSummaryUpdated: 'Vi har oppdatert analysen din – les den nye oppsummeringen din her',
    improvedInAreas_one: '{{count}} område er forbedret',
    improvedInAreas_other: '{{count}} områder er forbedret',
    areaStable_one: '{{count}} område er stabilt',
    areaStable_other: '{{count}} områder er stabile',
    needsAttention_one: '{{count}} område å se over',
    needsAttention_other: '{{count}} områder å se over',
    yourProgress: 'Din utvikling',
    progressVs: 'sammenlignet med {{date}}',
    seeAllProgress: 'Se hele utviklingen din, grafer og vurderinger her',
    symptomImproving: 'Forbedret',
    symptomStable: 'Stabilt',
    symptomNeedsAttention: 'Forverret',
    symptomResolved: 'Utbedret',
  },
  submitScreen: {
    followUpTitle: 'Send inn oppfølging',
    followUpSuccessTitle: 'Oppfølgingen din er sendt inn!',
    followUpInstructions: 'Nå har du svart på alle spørsmålene, og det gjenstår bare å sende inn oppfølgingen.',
    followUpProcess:
      'Hva skjer nå? Teamet vårt vil gjennomgå svarene dine for å vurdere hvordan allmenntilstanden din har utviklet seg og sammenstille individuelle anbefalinger basert på dine behov. Innen 3 arbeidsdager får du en e-post om at analysen er klar.',
    checkInTitle: 'Send inn innsjekking',
    checkInSuccessTitle: 'Innsjekkingen din er sendt inn!',
    checkInInstructions: 'Du er nå ferdig med innsjekkingen. Send inn svarene dine.',
    screeningTitle: 'Send inn screening',
    screeningSuccessTitle: 'Screeningen din er sendt inn!',
    screeningInstructions: 'Nå har du svart på alle spørsmålene, og det gjenstår bare å sende inn screeningen.',
    screeningProcess:
      'Hva skjer videre? Helseteamet vårt vil begynne å arbeide med din personlige analyse og helseplan. Innen 3 virkedager vil du få e-post om at resultatene dine er klare - vi er overbevist om at du vil ønske å ta neste steg på helsereisen din!',
    endFollowUpNoBookingRequest:
      'Takk for svarene dine! Vi kommer tilbake innen tre virkedager med oppdaterte råd og anbefalinger i helseplanen din. Allerede nå kan du følge hvordan helsen din har utviklet seg over tid i helseplanen din.',
    endFollowUpBookingRequest:
      'Takk for svarene dine! Vi kommer tilbake innen tre virkedager med oppdaterte råd og anbefalinger i helseplanen din. Siden du ønsket hjelp med å bestille en konsultasjon, kan du sende en bestillingsforespørsel allerede nå. Vi kommer tilbake så snart som mulig med et forslag til tid for enten et fysisk eller digitalt møte.',
    endFollowUpPregnancyEnded:
      'Takk for svarene dine! Vi ser at situasjonen din har endret seg siden du gjennomførte screeningen forrige gang. Vil du gjøre screeningen på nytt og få en oppdatert helseplan?',
    endCheckInNoBookingNoCall:
      'Takk for svarene dine! Nå er denne kortere innsjekkingen ferdig. Vi kommer tilbake til deg når det er tid for en mer omfattende oppfølging av ditt velvære. Da vil du registrere symptomene dine og deretter få nye, oppdaterte anbefalinger. Vil du snakke med en jordmor nå? Bestill en gratis helsesamtale der du kan stille spørsmål og få råd, støtte og veiledning om helsen din.',
    endCheckInNoBookingRequestHasCall:
      'Takk for svarene dine! Nå er denne kortere innsjekkingen ferdig. Vi kommer tilbake til deg når det er tid for en mer omfattende oppfølging av ditt velvære. Da vil du registrere symptomene dine og deretter få nye, oppdaterte anbefalinger. Har du noen spørsmål om helseplanen din eller ditt velvære? Du er hjertelig velkommen til å chatte med en av våre jordmødre for å få raske svar på spørsmålene dine.',
    endCheckInBookingRequest:
      'Takk for svarene dine! Nå er denne kortere innsjekkingen ferdig. Vi kommer tilbake til deg når det er tid for en mer omfattende oppfølging av ditt velvære. Da vil du registrere symptomene dine og deretter få nye, oppdaterte anbefalinger. Siden du ønsket hjelp med å bestille en konsultasjon, kan du sende en bestillingsforespørsel allerede nå. Vi kommer tilbake så snart som mulig med et forslag til tid for enten et fysisk eller digitalt møte.',
    endStandardBookingRequest:
      'Takk for svarene dine! Helseteamet vårt vil begynne å arbeide med din personlige analyse og helseplan. Innen 3 virkedager vil du få e-post om at resultatene dine er klare. Siden du ønsket hjelp med å bestille en konsultasjon, kan du sende en bestillingsforespørsel allerede nå. Vi kommer tilbake så snart som mulig med et forslag til tid for enten et fysisk eller digitalt møte.',
    endBookingRequestButton: 'Send forespørsel om konsultasjon',
    endCheckInNoBookingNoCallButton: 'Bestill helsesamtale med en jordmor',
    endStartConversationButton: 'Chat med en jordmor',
    endFollowUpNoBookingRequestButton: 'Se din helseutvikling',
    endFollowUpPregnancyEndedButton: 'Start ny screening',
    endTitle: 'Takk for svarene dine!',
  },
  trainings: {
    title: 'Opplæring',
    description:
      'Opplæring innen kvinnehelse er avgjørende for å øke bevisstheten om kvinners unike helsebehov. Gjennom økt kunnskap kan vi redusere stigma, forbedre arbeidsmiljøer og fremme en mer inkluderende og sunn organisasjon.',
    completedMessage: 'Du har gjennomført opplæringen',
  },
  support: {
    questionsTitle: 'Har du andre spørsmål?',
    contactText: 'Send e-post til support@estercare.com så hjelper vi deg!',
  },
  messages: {
    title: 'Chat',
    startConversation: 'Start en ny samtale',
    emptyTitle: 'Helseteamet ditt er her for deg',
    emptyDescription:
      'Still spørsmål, del tanker eller få veiledning rundt din helseplan og din velvære. Ingen spørsmål er for små, vi er her for deg. Vårt helseteam svarer vanligvis innen 24 timer på hverdager.',
    topicsLabel: 'Eksempler på hva du kan spørre om',
    topicDiet: 'Kosthold',
    topicSleep: 'Søvn',
    topicStress: 'Stressmestring',
    topicMentalHealth: 'Psykisk velvære',
    topicOutcomes: 'Helseplanens resultater',
    topicDetails: 'Helseplanens detaljer',
    topicSelfCare: 'Egenomsorg',
    messageLabel: 'Din melding',
    messagePlaceholder: 'Beskriv dine spørsmål eller tanker...',
    bookingRequestTemplate:
      'Hei, jeg ønsker hjelp med å bestille en konsultasjon etter å ha gjennomført screeningen.\n\nMitt fødselsnummer: \nMitt telefonnummer: ',
    sendButton: 'Send din melding',
    replyTime:
      'Spørsmålene dine behandles konfidensielt og besvares av autorisert helsepersonell. Vi svarer vanligvis innen 24 timer på hverdager.',
    healthTeam: 'EsterCare Helseteam',
    responseInfo: 'Autorisert helsepersonell svarer deg innen 24 timer. Du får et varsel via e-post.',
    writeMessage: 'Skriv din melding...',
    tableHeaderId: 'Melding',
    tableHeaderStatus: 'Status',
    tableHeaderLastMessageDate: 'Sist oppdatert',
    closedCase: 'Avsluttet',
    relativeTimeJustNow: 'Akkurat nå',
    relativeTimeMinutesAgo: 'm siden',
    relativeTimeHoursAgo: 't siden',
    relativeTimeYesterday: 'I går',
    relativeTimeDaysAgo: 'dager siden',
    fallbackSender: 'Du:',
    selectConversationFooter:
      'Har du spørsmål om EsterCare? Sjekk ut våre <highlight>vanlige spørsmål og svar</highlight>.',
    createError: 'Noe gikk galt, prøv igjen litt senere.',
    conversationClosedTitle: 'Samtalen er avsluttet.',
    conversationClosedDescription:
      'Du kan alltid starte en ny samtale hvis du har flere spørsmål eller trenger ytterligere hjelp.',
  },
  knowledgeBank: {
    articlesCount: 'Artikler ({{count}})',
    podcastsCount: 'Podkastepisoder ({{count}})',
    allPodcasts: 'Alle podkastepisoder',
    allArticles: 'Alle artikler',
    episodeTitle: 'Episode {{episodeNumber}}: {{title}}',
    aboutEpisode: 'Om episoden',
    relatedPodcasts: 'Relaterte podkaster',
    relatedArticles: 'Relaterte artikler',
    swedishOnly: 'Denne podkastepisoden er på svensk.',
  },
} as const
